import { IBuildingItem, IBuilding } from 'models';
import BuildingThumbnailPlaceholderImg from 'assets/images/building_thumbnail_placeholder.png';

export const getBuildingLocation = (building: IBuilding, showZip = true) => {
  let location = `${building.address}, ${building.city}, ${building.state}`;

  if (showZip) {
    location = `${location}, ${building.zip}`;
  }

  return location;
};

export const getBuildingImageUrl = (building?: IBuilding, placeholderImage = true) => {
  if (!building || !building.thumbnail || !building.thumbnail.url) {
    return placeholderImage ? BuildingThumbnailPlaceholderImg : '';
  }

  return `${building.thumbnail.url}?${building.thumbnail.size}`;
};

const isLocation = (building: IBuildingItem, keyword: string) =>
  building.location.toLowerCase().includes(keyword.toLowerCase());

const isFloors = (building: IBuildingItem, keyword: string) =>
  `${building.floors} floors`.toLowerCase().includes(keyword.toLowerCase());

const isFiltered = (building: IBuildingItem, keyword: string) => {
  return isLocation(building, keyword) || isFloors(building, keyword);
};

export const filterBuildingItems = (buildings?: Array<IBuildingItem>, keyword?: string) => {
  if (!buildings || buildings.length === 0) {
    return [];
  }

  if (!keyword) {
    return buildings;
  }

  return buildings.filter((building) => isFiltered(building, keyword));
};
